export function updateGameSettings(gameSettings) {
    return { type: 'GAME_UPDATE_SETTINGS', payload: gameSettings };
}

export function updatePlayerSettings(playerSettings) {
    return { type: 'GAME_UPDATE_PLAYER_SETTINGS', payload: playerSettings };
}

export function createLevel(uuid) {
    return { type: 'GAME_CREATE_LEVEL', payload: uuid };
}

export function moveLevel(prevPosition, newPosition) {
    return {
        type: 'GAME_MOVE_LEVEL',
        payload: {
            idxToMove: prevPosition,
            idxToReplace: newPosition
        }
    };
}

export function deleteLevel(uuid) {
    return { type: 'GAME_DELETE_LEVEL', payload: uuid };
}

export function updateLevelThumbnail(levelUUID, dataURL) {
    return {
        type: 'GAME_UPDATE_THUMBNAIL',
        payload: {
            uuid: levelUUID,
            url: dataURL
        }
    };
}

export function updateLevelDescription(levelUUID, description) {
    return {
        type: 'GAME_UPDATE_DESC',
        payload: {
            uuid: levelUUID,
            desc: description
        }
    };
}

export function setGameThumbnail(levelUUID) {
    return {
        type: 'GAME_SET_GAME_THUMBNAIL',
        payload: {
            uuid: levelUUID
        }
    };
}

export function updateLoadProgress(progress, text) {
    return { type: 'GAME_UPDATE_LOADING_PROGRESS', payload: { progress, text } };
}

export function setLoadingComplete(complete) {
    return { type: 'GAME_SET_LOADING_COMPLETE', payload: complete};
}
